import { VARIABLE_REGEX, normalizeVariablePath } from '@westhetics/legal'

/**
 * Números que ajudam quem escreve: palavras, tempo de leitura (200 palavras por minuto —
 * o ritmo de quem lê no celular com atenção), seções, cláusulas e variáveis.
 */
export interface DocumentStats {
  words: number
  characters: number
  readingMinutes: number
  sections: number
  clauses: number
  variables: number
  blocks: number
}

export function computeStats(markdown: string): DocumentStats {
  const withoutFrontMatter = markdown.replace(/^---[\s\S]*?\n---\n?/, '')
  const text = withoutFrontMatter
    .replace(/^:{2,3}\w+.*$/gm, '')
    .replace(/^:::$/gm, '')
    .replace(/[#>*_`|-]/g, ' ')
  const words = text.split(/\s+/).filter((w) => /\p{L}|\p{N}/u.test(w)).length
  return {
    words,
    characters: withoutFrontMatter.length,
    readingMinutes: Math.max(1, Math.round(words / 200)),
    sections: (withoutFrontMatter.match(/^## /gm) ?? []).length,
    clauses: (withoutFrontMatter.match(/^### /gm) ?? []).length,
    variables: new Set(
      [...withoutFrontMatter.matchAll(VARIABLE_REGEX)].map((m) =>
        normalizeVariablePath(m[1] ?? ''),
      ),
    ).size,
    blocks: (withoutFrontMatter.match(/^:::\w+/gm) ?? []).length,
  }
}
